module.exports = __webpack_public_path__ + "static/img/gm_open04.b7123282.png";